export {version as default} from '../package.json';



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/proj4/lib/version.js
// module id = ../../../../proj4/lib/version.js
// module chunks = vendor